<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="secondary">
            <dropdown
                :value="selectedPosition"
                :options="positionOptions"
                native
                @input="onPositionInput"
            />
        </template>

        <template slot="primary">
            <dropdown
                :value="selectedPlacement"
                :options="placementOptions"
                native
                @input="onPlacementInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import { mapMutations } from 'vuex';

import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';
import { SHOW_SNACKBAR } from '@/store/types/mutation-types';

export default {
    name: 'placement',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Placement',
            message: '* note that this will not have any effect while you are in editing mode. You must switch to preview mode in order to see its effects.',
            selectedPlacement: '',
            selectedPosition: 'absolute',
            tailwindDefinitionProp: 'placement',

            positionOptions: [
                { text: 'Default', value: 'absolute' },
                { text: 'Fixed', value: 'fixed' },
            ],
        };
    },

    computed: {
        placementOptions() {
            return this.themeObjectKeys
                .filter((k) => {
                    // always show a "none" option
                    if (k === 'none') return true;

                    return this.selectedPosition === 'fixed' ? k.includes('fixed') : !k.includes('fixed');
                })
                .map((k) => {
                    return {
                        text: this.titleCase(k.replace('fixed-', '')),
                        value: k,
                    };
                });
        },
    },

    watch: {
        changedOption({ option }) {
            if (option === 'offset') this.onConflict();
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        ...mapMutations({
            showSnackbar: SHOW_SNACKBAR,
        }),

        getOptionValues(array) {
            return array.map(o => o.value);
        },

        onPlacementInput(placementNew) {
            if (placementNew === 'none') {
                this.onPositionRemove();
            } else {
                this.onPositionAdd(placementNew);
            }

            this.selectedPlacement = placementNew;
            this.onOptionChange();
        },

        onPositionAdd(placementNew) {
            switch (this.screen) {
                case 'mob':
                    this.addFlexClass({ key: placementNew, screen: 'mob' });
                    break;

                case 'tab':
                    this.addFlexClass({ key: placementNew, screen: 'tab' });
                    break;

                case 'lap':
                    this.addFlexClass({ key: placementNew, screen: 'lap' });
                    break;

                default:
                    this.addFlexClass({ key: placementNew, screen: 'mob' });
                    this.addFlexClass({ key: placementNew, screen: 'tab' });
                    this.addFlexClass({ key: placementNew, screen: 'lap' });
                    this.addFlexClass({ key: placementNew, screen: 'des' });
            }

            if (this.selectedPosition === 'fixed') {
                this.showSnackbar({
                    title: 'Changes Applied!',
                    text: 'Note that this particular option will only take effect in preview mode.',
                });
            }
        },

        onPositionRemove() {
            switch (this.screen) {
                case 'mob':
                    this.removeFlexClass('default', 'mob');
                    break;

                case 'tab':
                    this.removeFlexClass('default', 'tab');
                    break;

                case 'lap':
                    this.removeFlexClass('default', 'lap');
                    break;

                default:
                    this.removeFlexClass('default', 'mob');
                    this.removeFlexClass('default', 'tab');
                    this.removeFlexClass('default', 'lap');
                    this.removeFlexClass('default', 'des');
            }
        },

        onPositionInput(positionNew) {
            this.selectedPlacement = 'none';
            this.selectedPosition = positionNew;
        },

        onSelectedElement() {
            const { key } = this.flexClassDefinition;

            this.selectedPlacement = key || 'none';
            this.selectedPosition = key && key.includes('fixed') ? 'fixed' : 'absolute';
        },

        onConflict() {
            this.removeFlexClass('default', 'mob');
            this.removeFlexClass('default', 'tab');
            this.removeFlexClass('default', 'lap');
            this.removeFlexClass('default', 'des');

            this.selectedPlacement = 'none';
            this.selectedPosition = 'absolute';
        },
    },
};
</script>
